// Polyfills for production environment
// Fix for Supabase client in production builds

// Critical: Set up global objects before anything else
(function() {
  // Ensure global is defined
  if (typeof global === 'undefined') {
    (window as any).global = window;
  }

  // Ensure globalThis is defined
  if (typeof globalThis === 'undefined') {
    (window as any).globalThis = window;
  }
  
  // Ensure self is defined
  if (typeof self === 'undefined') {
    (window as any).self = window;
  }
})();

// Ensure process is defined with minimal properties
if (typeof process === 'undefined') {
  (window as any).process = {
    env: {},
    version: '',
    versions: {},
    browser: true,
    nextTick: (fn: Function) => setTimeout(fn, 0)
  };
}

// Ensure Buffer is available globally
if (typeof Buffer === 'undefined') {
  (window as any).Buffer = (window as any).Buffer || {
    isBuffer: () => false
  };
}

// Polyfill for AbortController if not available
if (typeof AbortController === 'undefined') {
  (window as any).AbortController = class AbortController {
    signal = {
      aborted: false,
      addEventListener: () => {},
      removeEventListener: () => {},
      dispatchEvent: () => true,
      onabort: null
    };
    abort() {
      this.signal.aborted = true;
    }
  };
}

// Fix for Headers/Request/Response in production
(function() {
  // Ensure Headers constructor exists and works properly
  if (typeof Headers === 'undefined' || !window.Headers) {
    if (import.meta.env.DEV) {

      if (import.meta.env.DEV) {
        console.warn('Headers not available, using polyfill');
      }

    }
  }
  
  // Patch fetch-related constructors if they exist but are broken
  if (typeof window !== 'undefined') {
    const originalFetch = window.fetch;
    if (originalFetch) {
      window.fetch = function(input, init) {
        // Ensure init object has proper structure
        if (init && typeof init === 'object') {
          if (init.headers && !(init.headers instanceof Headers)) {
            init.headers = new Headers(init.headers);
          }
        }
        return originalFetch.call(window, input, init);
      };
    }
  }
})();

// Add headers polyfill if needed
if (typeof Headers === 'undefined') {
  (window as any).Headers = class Headers {
    private headers: Record<string, string> = {};
    
    constructor(init?: HeadersInit) {
      if (init) {
        if (init instanceof Headers) {
          init.forEach((value, key) => {
            this.headers[key.toLowerCase()] = value;
          });
        } else if (Array.isArray(init)) {
          init.forEach(([key, value]) => {
            this.headers[key.toLowerCase()] = value;
          });
        } else {
          Object.entries(init).forEach(([key, value]) => {
            this.headers[key.toLowerCase()] = value;
          });
        }
      }
    }
    
    append(key: string, value: string) {
      this.headers[key.toLowerCase()] = value;
    }
    
    get(key: string) {
      return this.headers[key.toLowerCase()] || null;
    }
    
    has(key: string) {
      return key.toLowerCase() in this.headers;
    }
    
    set(key: string, value: string) {
      this.headers[key.toLowerCase()] = value;
    }
    
    forEach(callback: (value: string, key: string) => void) {
      Object.entries(this.headers).forEach(([key, value]) => {
        callback(value, key);
      });
    }
  };
}

// Only log in development for security
if (import.meta.env.DEV) {
  // console.log('🚀 Development polyfills loaded');
  console.log('Window properties:', {
    global: typeof global !== 'undefined',
    globalThis: typeof globalThis !== 'undefined',
    Headers: typeof Headers !== 'undefined',
    fetch: typeof fetch !== 'undefined',
    AbortController: typeof AbortController !== 'undefined'
  });
}

export {};